import { useMutation, useQueryClient } from '@tanstack/react-query';
import { isArray } from 'lodash';

import patchChangeDevice from 'Api/monitoring/patchChangeDevice';
import { useLoader } from 'Store/loader';
import { useToast } from 'Store/toast';
import { patchChangeDeviceText } from 'Const/monitoring/domain';

import patchChangeDevicePayload from './model/request/patchChangeDevicePayload';

const usePatchChangeDevice = () => {
  const { onShowLoader, onResetLoader } = useLoader();
  const { onOpenToast } = useToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (formData) => {
      const payload = patchChangeDevicePayload(formData);

      const result = await patchChangeDevice(payload);

      return result;
    },
    onMutate: () => onShowLoader({ variant: 'loader-primary' }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['monitoring-operator-status'] });

      return onOpenToast({ status: 'success', description: patchChangeDeviceText.successDescriptionText, duration: 5, alwaysShow: false });
    },
    onError: (error) => {
      console.log(error);
      const errorMessage = isArray(error?.response?.data?.errors) ? error?.response?.data?.errors[0]?.message : patchChangeDeviceText.defaultErrorMessageText;

      onOpenToast({ status: 'error', description: errorMessage, duration: 5, alwaysShow: false });
    },
    onSettled: () => onResetLoader(),
  });
};

export default usePatchChangeDevice;
